import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
  }

  close(e) {
    // this.element.classList.remove("open");
  }
}
